import { Layout } from 'antd'
import styled from 'styled-components'

const { Header } = Layout

export const HeaderForpy = styled(Header)`
    position: absolute;
    width: 100%;
    z-index: 98;
    top:  0px;
    left: 0px;
    display: flex;
    align-items: center;
    border-left: 0px;
    padding: 12px 16px !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

    a {
        margin-left: 16px;
        transition: var(--transition);

        &:hover {
            opacity: 0.7;
            transition: var(--transition);
        }
        
        .logo {
            aspect-ratio: 131 / 35.54;
            width: 100px;
        }

    }


    .page-title {
        color: var(--blue-darker);
        font-size: 1.5rem;
        text-align: center;
        width: 100%;

        @media (min-width: 760px) {
            display: none;
        }
    }
`
